import { MutationType } from '@tencent/slide-sdk-pb-model';
import { SubChart } from '../mutation/shape/chart/sub-chart';
import { cloneDeep } from '../utils/clone-deep';
import type { IChartData, ISubChartData } from '../data';
import type {
    IValidAddSubChartMutationData,
    IValidMutationData,
    IValidSetChartSpacePropertiesMutationData,
    IValidSetSubChartPropertiesMutationData,
} from '../mutation/base';
import type { KeyframeContext } from './keyframe-context.interface';
import type { MarkRequired } from 'ts-essentials';

export function getChartKeyframe(
    graphicChart: IChartData,
    context: MarkRequired<KeyframeContext, 'page'>,
): IValidMutationData[] {
    const mutations: IValidMutationData[] = [];

    const pageId = context.idFactory(context.page.id);
    const shapeId = context.idFactory(graphicChart.id);

    // 添加一个图表的过程为：
    // AddShape
    // => SetChartSpacePropertiesMutationData
    // => AddSubChartMutationData
    // => SetSubChartPropertiesMutationData
    const chartSpaceData = cloneDeep(graphicChart.chartSpace);
    if (chartSpaceData) {
        const subChartList = chartSpaceData.chart?.plotArea?.charts;
        // mutation上是没有charts这个属性的，要干掉
        if (subChartList !== undefined) {
            delete chartSpaceData?.chart?.plotArea?.charts;
        }

        const setChartSpace = {
            type: MutationType.SetChartSpaceProperties,
            shapeId,
            pageId,
            chartSpacePr: chartSpaceData,
        } satisfies IValidSetChartSpacePropertiesMutationData;
        mutations.push(setChartSpace);

        subChartList?.forEach((subChart: ISubChartData, index: number) => {
            const addSubChart = {
                type: MutationType.AddSubChart,
                shapeId,
                pageId,
                index,
                subChartType: subChart.type,
            } satisfies IValidAddSubChartMutationData;
            mutations.push(addSubChart);

            const setSubChart = {
                type: MutationType.SetSubChartProperties,
                shapeId,
                pageId,
                index,
                plot: new SubChart().createEgPlotBySubChart(subChart),
                axesPr: {
                    axes: subChart.axes,
                    index: subChart.axesAddIndex,
                },
            } satisfies IValidSetSubChartPropertiesMutationData;
            mutations.push(setSubChart);
        });
    }

    return mutations;
}
